import React from 'react';
import { COLORS, fontSizes } from '../constants/constants';
import Text from './Text';
import '../App.css';
import dynamicfunction from '../utils/dynamicfunction';
import { DatePicker, LocalizationProvider, PickersDay } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/ar';
import { createTheme, ThemeProvider } from '@mui/material';

const theme = createTheme({
  components: {
    MuiPickersYear: {
      styleOverrides: {
        root: {
          borderWidth: '1px',
          borderColor: COLORS.grey,
          borderRadius: '4px',
          margin: '4px',
          height: '40px',
          cursor: 'pointer',
          flex: 1,
          maxWidth: '96px',
        },
      },
      selected: {
        flex: 1,
      },
    },
  },
});

const CustomDatePicker = ({
  label,
  divClasses,
  onChange,
  width = 'w-full',
  labelColor,
  isError,
  placeholder,
  selectedDate,
  isFullborder = true,
  isRequired = false,
  maxDate,
  minDate,
  props,
}) => {
  const { isArabic } = dynamicfunction();

  return (
    <ThemeProvider theme={theme}>
      <div className={`${divClasses} ${width}`}>
        <Text
          text={label && label}
          size={fontSizes.h14}
          color={isError ? 'text-red-500' : labelColor}
          className={'mb-1'}
          isRequired={isRequired}
        />
        <div className={`${isFullborder ? 'border rounded-md' : 'border-b-2'} ${isError ? 'border-red-600' : 'border-grey'} py-1 px-2`}>
          <LocalizationProvider
            adapterLocale={isArabic ? 'ar' : 'en'}
            dateAdapter={AdapterDayjs}
          >
            <DatePicker
              {...props}
              sx={{ height: '40px' }}
              maxDate={maxDate}
              minDate={minDate}
              className='w-full'
              onChange={onChange}
              format='DD/MM/YYYY'
              value={selectedDate ? dayjs(selectedDate) : null}
              slots={{
                day: (props) => (
                  <PickersDay
                    {...props}
                    sx={{
                      borderWidth: '1px',
                      borderColor: COLORS.grey,
                      borderStyle: 'solid',
                      borderRadius: '4px',
                      margin: ' 3px',
                      padding: '0px',
                      '&.Mui-selected': {
                        backgroundColor: COLORS.primary_light,
                        color: COLORS.white,
                        borderColor: COLORS.primary_light,
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: COLORS.primary_light + '80',
                        color: COLORS.white,
                      },
                      '&.Mui-selected:focus': {
                        backgroundColor: COLORS.primary_light,
                        color: COLORS.white,
                      },
                      '&.MuiPickersDay-today': {
                        borderColor: COLORS.primary_light + '30',
                        borderWidth: '2px',
                        backgroundColor: COLORS.primary_light + '30',
                        color: COLORS.black,
                      },
                      '&.Mui:hover': {
                        borderColor: COLORS.primary_light + '30',
                        borderWidth: '2px',
                        backgroundColor: COLORS.primary_light + '30',
                        color: COLORS.black,
                      },
                    }}
                  />
                ),
              }}
              enableAccessibleFieldDOMStructure={false}
              slotProps={{
                textField: {
                  variant: 'standard',
                  InputProps: {
                    disableUnderline: true,
                  },
                  inputProps: {
                    placeholder: placeholder || 'dd/mm/yyyy',
                  },
                  sx: {
                    '& .MuiInputBase-root': {
                      border: 'none',
                    },
                    '& .MuiInputBase-input': {
                      padding: '5px 0px',
                      fontSize: '14px',
                    },
                  },
                  dir: isArabic ? 'rtl' : 'ltr',
                },
                leftArrowIcon: {
                  fontSize: 'medium',
                  sx: { border: '1px solid #ccc', borderRadius: '50px', height: '30px', width: '30px', padding: '5px' },
                },
                rightArrowIcon: {
                  fontSize: 'medium',
                  sx: { border: '1px solid #ccc', borderRadius: '50px', height: '30px', width: '30px', padding: '5px' },
                },
              }}
            />
          </LocalizationProvider>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default CustomDatePicker;
